<template>
  <div class="sai_databox">
    <div v-if="(startList.homeTeamLeagueRank && startList.homeTeamLeagueRank.length > 0 )||  (startList.awayTeamLeagueRank && startList.awayTeamLeagueRank.length>0)">
      <div class="moduleName" style="margin-top: 0;">联赛积分排名</div>
      <div class="u-flex u-flex-between scorebang" v-if="scoreDetail.league">
        <div class="u-flex-y leftInfo">
          <div class="title">
            <img v-if="scoreDetail.homeTeam"
              :src="scoreDetail.homeTeam.customLogo?scoreDetail.homeTeam.customLogo:'/static/scope/defaultqiu.png'" alt=""
              srcset="">
            <span v-if="scoreDetail.homeTeam">{{scoreDetail.homeTeam.nameCn}}</span>
          </div>
          <div class="tableName u-flex u-flex-items-center">
            <div>全场</div>
            <div>塞</div>
            <div>胜</div>
            <div>平</div>
            <div>负</div>
            <div>得</div>
            <div>失</div>
            <div>净</div>
            <div>积分</div>
            <div class="bggreey">排名</div>
            <div>胜率</div>
          </div>
          <div class="datainfo u-flex u-flex-items-center" v-for="(item,index) in startList.homeTeamLeagueRank"
            :key='index'>
            <div>{{item.analysisType ==0?'总':item.analysisType ==1?'主':'客'}}</div>
            <div>{{item.totalCount}}</div>
            <div>{{item.winCount}}</div>
            <div>{{item.drawCount}}</div>
            <div>{{item.loseCount}}</div>
            <div>{{item.getScore}}</div>
            <div>{{item.loseScore}}</div>
            <div>{{item.goalDifference}}</div>
            <div>{{item.integral}}</div>
            <div class="bggreey">{{item.rank}}</div>
            <div>{{item.winRate}}%</div>
          </div>
          <div class="datainfo u-flex u-flex-items-center"
            v-if="startList.homeTeamLeagueRank && startList.homeTeamLeagueRank.length == 0" v-for="(index) in 3">
            <div>{{index == 1?'总':index ==2?'主':'客'}}</div>
            <div>-</div>
            <div>-</div>
            <div>-</div>
            <div>-</div>
            <div>-</div>
            <div>-</div>
            <div>-</div>
            <div>-</div>
            <div class="bggreey">-</div>
            <div>-</div>
          </div>

        </div>
        <div class="u-flex-y leftInfo">
          <div class="title">
            <img :src="scoreDetail.awayTeam.customLogo?scoreDetail.awayTeam.customLogo:'/static/scope/defaultqiu.png'"
              alt="" srcset="">
            <span v-if="scoreDetail.awayTeam"> {{scoreDetail.awayTeam.nameCn}}</span>
          </div>
          <div class="tableName u-flex u-flex-items-center">
            <div>全场</div>
            <div>塞</div>
            <div>胜</div>
            <div>平</div>
            <div>负</div>
            <div>得</div>
            <div>失</div>
            <div>净</div>
            <div>积分</div>
            <div class="bggreey">排名</div>
            <div>胜率</div>
          </div>
          <div class="datainfo u-flex u-flex-items-center" v-for="(item,index) in startList.awayTeamLeagueRank"
            :key='index'>
            <div>{{item.analysisType ==0?'总':item.analysisType ==1?'主':'客'}}</div>
            <div>{{item.totalCount}}</div>
            <div>{{item.winCount}}</div>
            <div>{{item.drawCount}}</div>
            <div>{{item.loseCount}}</div>
            <div>{{item.getScore}}</div>
            <div>{{item.loseScore}}</div>
            <div>{{item.goalDifference}}</div>
            <div>{{item.integral}}</div>
            <div class="bggreey">{{item.rank}}</div>
            <div>{{item.winRate}}%</div>
          </div>
          <div class="datainfo u-flex u-flex-items-center"
            v-if="startList.awayTeamLeagueRank && startList.awayTeamLeagueRank.length == 0" v-for="(index) in 3">
            <div>{{index == 1?'总':index ==2?'主':'客'}}</div>
            <div>-</div>
            <div>-</div>
            <div>-</div>
            <div>-</div>
            <div>-</div>
            <div>-</div>
            <div>-</div>
            <div>-</div>
            <div class="bggreey">-</div>
            <div>-</div>
          </div>
        </div>
      </div>
    </div>


    <!-- 历史交锋 -->
    <div class="moduleName"  v-if="historyList.matchList && historyList.matchList.length > 0">历史交锋</div>
    <div class="historyData" v-if="historyList.matchList && historyList.matchList.length > 0">
      <div class="u-flex tablisthistory u-flex-between u-flex-items-center">
        <div>全部赛事</div>
        <div style="flex: 2;display:flex;align-items: center; justify-content: flex-end;margin-right: 20px;">
          <div class="checkGroupSelect" @click="nearChangeData('a',1)">
            <span :class="pramsInfo.historyRadio1 == 1?'checkActive':''"></span>
            同主客
          </div>
          <div class="checkGroupSelect" @click="nearChangeData('b',1)">
            <span :class="pramsInfo.historyRadio2 == 1?'checkActive':''"></span>
            同赛事
          </div>
          <div class="checkGroupSelect" @click="nearChangeData('c',1)">
            <span :class="pramsInfo.historyRadio3 == 1?'checkActive':''"></span>
            半场
          </div>
        </div>
        <div class="switchTabs">
          <span @click="changelist(10,1)">近10</span>
          <span @click="changelist(20,1)">近20</span>
          <div :class="showPageNumber.history == 10?'nearly1':'nearly2'">{{showPageNumber.history == 10?'近10':'近20'}}
          </div>
        </div>
      </div>
      <div class="u-flex historyItem">
        <div class="itemsblock1">赛事</div>
        <div class="itemsblock1">比赛日期</div>
        <div class="itemsblock2">主队</div>
        <div class="itemsblock5">比分</div>
        <div class="itemsblock2" style="justify-content: flex-start;">客队</div>
        <div class="itemsblock5">半场</div>
        <div class="itemsblock5">角球</div>
        <div class="itemsblock5">胜负</div>
        <div class="itemsblock4">胜负</div>
        <div class="itemsblock4">让球</div>
        <div class="itemsblock5">走势</div>
        <div class="itemsblock5">进球数</div>
      </div>
      <!-- 初盘 -->
      <div class="u-flex historyItem" v-if="item.league" v-for="(item,index) in historyList.matchList" :key="index">
        <div class="itemsblock1">{{item.league.nameCnShort}}</div>
        <div class="itemsblock1">{{fifiData(item.matchInfo.matchStartTime)}}</div>
        <div class="itemsblock2" :style="{'color':baseStateData(item,item.homeTeam.nameCn,pramsInfo.historyRadio3,1).color}">{{item.homeTeam.nameCn}} <img
            style="margin-left:4px" v-if="item.homeTeam"
            :src="item.homeTeam.customLogo?item.homeTeam.customLogo:'/static/scope/defaultqiu.png'" alt="" srcset="">
        </div>
        <div class="itemsblock5 homeColorUp">{{item.matchData.homeScore}} - {{item.matchData.awayScore}}</div>
        <div class="itemsblock2" style="justify-content: flex-start;"
          :style="{'color':baseStateData(item,item.awayTeam.nameCn,pramsInfo.historyRadio3,2).color}">
          <img v-if="item.homeTeam" style="margin-right:4px"
            :src="item.awayTeam.customLogo?item.awayTeam.customLogo:'/static/scope/defaultqiu.png'" alt=""
            srcset="">{{item.awayTeam.nameCn}}
        </div>
        <div class="itemsblock5"> {{item.matchData.homeHalfScore}}-{{item.matchData.awayHalfScore}}</div>
        <div class="itemsblock5">{{item.matchData.homeCornerNum}}-{{item.matchData.awayCornerNum}}</div>

       <div class="itemsblock5" :style="{'color':winstate(item,pramsInfo.historyRadio3).color}">
         {{winstate(item,pramsInfo.historyRadio3).name}}
       </div>
        <!-- 欧赔 初盘-->
        <div class="itemsblock4">
          <span>{{item.europeFirstHomeOdds}}</span>
          <span>{{item.europeFirstFlatOdds}}</span>
          <span>{{item.europeFirstAwayOdds}}</span>
        </div>
        <div class="itemsblock4">
          <span>{{item.asiaFirstHomeOdds}}</span>
          <span>{{item.asiaFirstGoal}}</span>
          <span>{{item.asiaFirstAwayOdds}}</span>
        </div>
        <div class="itemsblock5" :style="{'color':winrunState(item,1)}">
          {{item.asiaResult?item.asiaResult:'-'}}
        </div>
        <div class="itemsblock5" :style="{'color':winrunState(item,2)}">
          {{item.bsResult?item.bsResult:'-'}}
        </div>
      </div>
      <!--  -->
      <div class="totalTxt">
        两队近{{historyList.num}}场交锋 <b> {{scoreDetail.homeTeam.nameCn}}</b> 胜 <span>{{historyList.winCount}}</span> 场，平
        <span style="color: #1076E9;">{{historyList.flatCount}}</span> 场，负 <span
          style="#58AF66">{{historyList.loseCount}}</span>
        场，胜率：<span>{{mathData( historyList.winRate , 100)}}%</span>，赢率：<span>{{mathData( historyList.asiaRate ,100)}}%</span>，大率：<span>{{mathData( historyList.upRate , 100)}}%</span>
      </div>
    </div>
    <!-- 近期战绩 -->
    <div class="moduleName"  v-if="nearlyList.homeRecordAnalysis && nearlyList.homeRecordAnalysis.matchList.length > 0 && nearlyList2.awayRecordAnalysis && nearlyList2.awayRecordAnalysis.matchList.length >0">近期战绩</div>
    <div class="historyData" v-if="nearlyList.homeRecordAnalysis && nearlyList.homeRecordAnalysis.matchList.length > 0">
      <div class="u-flex tablisthistory u-flex-between u-flex-items-center">
        <img style="width: 20px;height: 20px;margin-right: 4px;" v-if="scoreDetail.homeTeam"
          :src="scoreDetail.homeTeam.customLogo?scoreDetail.homeTeam.customLogo:'/static/scope/defaultqiu.png'" alt=""
          srcset="">
        <div v-if="scoreDetail.homeTeam">{{scoreDetail.homeTeam.nameCn}}</div>
        <div style="flex: 2;display:flex;align-items: center; justify-content: flex-end;margin-right: 20px;">
          <div class="checkGroupSelect" @click="nearChangeData('a',2)">
            <span :class="pramsInfo.nearlyHomeRadio1 == 1?'checkActive':''"></span>
            同主客
          </div>
          <div class="checkGroupSelect" @click="nearChangeData('b',2)">
            <span :class="pramsInfo.nearlyHomeRadio2 == 1?'checkActive':''"></span>
            同赛事
          </div>
          <div class="checkGroupSelect" @click="nearChangeData('c',2)">
            <span :class="pramsInfo.nearlyHomeRadio3 == 1?'checkActive':''"></span>
            半场
          </div>
        </div>
        <div class="switchTabs">
          <span @click="changelist(10,2)">近10</span>
          <span @click="changelist(20,2)">近20</span>
          <div :class="showPageNumber.nearly1 == 10?'nearly1':'nearly2'">{{showPageNumber.nearly1 == 10?'近10':'近20'}}
          </div>
        </div>
      </div>
      <div class="u-flex historyItem">
        <div class="itemsblock1">赛事</div>
        <div class="itemsblock1">比赛日期</div>
        <div class="itemsblock2">主队</div>
        <div class="itemsblock5">比分</div>
        <div class="itemsblock2" style="justify-content: flex-start;">客队</div>
        <div class="itemsblock5">半场</div>
        <div class="itemsblock5">角球</div>
        <div class="itemsblock5">胜负</div>
        <div class="itemsblock4">胜负</div>
        <div class="itemsblock4">让球</div>
        <div class="itemsblock5">走势</div>
        <div class="itemsblock5">进球数</div>
      </div>
      <!-- 初盘 -->
      <div v-if="nearlyList.homeRecordAnalysis">
        <div class="u-flex historyItem" v-if="item.league"
          v-for="(item,index) in nearlyList.homeRecordAnalysis.matchList" :key="index">
          <div class="itemsblock1">{{item.league.nameCnShort}}</div>
          <div class="itemsblock1">{{fifiData(item.matchInfo.matchStartTime)}}</div>

          <div class="itemsblock2"  :style="{'color':baseStateData(item,item.homeTeam.nameCn,pramsInfo.nearlyHomeRadio3,1).color}">{{item.homeTeam.nameCn}} <img
              style="margin-left:4px" v-if="item.homeTeam"
              :src="item.homeTeam.customLogo?item.homeTeam.customLogo:'/static/scope/defaultqiu.png'" alt="" srcset="">
          </div>

          <div class="itemsblock5 homeColorUp">{{item.matchData.homeScore}} - {{item.matchData.awayScore}}</div>
          <div class="itemsblock2" style="justify-content: flex-start;"
          :style="{'color':baseStateData(item,item.awayTeam.nameCn,pramsInfo.nearlyHomeRadio3,2).color}"><img
              v-if="item.awayTeam" style="margin-right:4px"
              :src="item.awayTeam.customLogo?item.awayTeam.customLogo:'/static/scope/defaultqiu.png'" alt=""
              srcset="">{{item.awayTeam.nameCn}}</div>
          <div class="itemsblock5"> {{item.matchData.homeHalfScore}}-{{item.matchData.awayHalfScore}}</div>
          <div class="itemsblock5">{{item.matchData.homeCornerNum}}-{{item.matchData.awayCornerNum}}</div>

          <div class="itemsblock5" :style="{'color':winstate(item,pramsInfo.nearlyHomeRadio3).color}">
            {{winstate(item,pramsInfo.nearlyHomeRadio3).name}}
          </div>
          <!-- 欧赔 初盘-->
          <div class="itemsblock4">
            <span>{{item.europeFirstHomeOdds}}</span>
            <span>{{item.europeFirstFlatOdds}}</span>
            <span>{{item.europeFirstAwayOdds}}</span>
          </div>
          <div class="itemsblock4">
            <span>{{item.asiaFirstHomeOdds}}</span>
            <span>{{item.asiaFirstGoal}}</span>
            <span>{{item.asiaFirstAwayOdds}}</span>
          </div>
          <div class="itemsblock5" :style="{'color':winrunState(item,1)}">
            {{item.asiaResult?item.asiaResult:'-'}}
          </div>
          <div class="itemsblock5" :style="{'color':winrunState(item,2)}">
            {{item.bsResult?item.bsResult:'-'}}
          </div>
        </div>
        <!--  -->

        <div class="totalTxt">
          两队近{{nearlyList.homeRecordAnalysis.num}}场交锋 <b> {{scoreDetail.homeTeam.nameCn}} </b> 胜
          <span>{{nearlyList.homeRecordAnalysis.winCount}}</span> 场，平 <span
            style="color: #1076E9;">{{nearlyList.homeRecordAnalysis.flatCount}}</span> 场，负 <span
            style="#58AF66">{{nearlyList.homeRecordAnalysis.loseCount}}</span>
          场，胜率：<span>{{mathData( nearlyList.homeRecordAnalysis.winRate ,100 )}}%</span>，赢率：<span>{{mathData( nearlyList.homeRecordAnalysis.asiaRate ,100)}}%</span>，大率：<span>{{mathData( nearlyList.homeRecordAnalysis.upRate ,100)}}%</span>
        </div>
      </div>
    </div>


    <div class="historyData" style="margin-top: 10px;" v-if="nearlyList2.awayRecordAnalysis && nearlyList2.awayRecordAnalysis.matchList.length >0">
      <div class="u-flex tablisthistory u-flex-between u-flex-items-center">
        <img style="width: 20px;height: 20px;margin-right: 4px;" v-if="scoreDetail.awayTeam"
          :src="scoreDetail.awayTeam.customLogo?scoreDetail.awayTeam.customLogo:'/static/scope/defaultqiu.png'" alt=""
          srcset="">
        <div v-if="scoreDetail.awayTeam">{{scoreDetail.awayTeam.nameCn}}</div>

        <div style="flex: 2;display:flex;align-items: center; justify-content: flex-end;margin-right: 20px;">


          <div class="checkGroupSelect" @click="nearChangeData('a',3)">
            <span :class="pramsInfo.nearlyAwaiyRadio1 == 1?'checkActive':''"></span>
            同主客
          </div>
          <div class="checkGroupSelect" @click="nearChangeData('b',3)">
            <span :class="pramsInfo.nearlyAwaiyRadio2 == 1?'checkActive':''"></span>
            同赛事
          </div>
          <div class="checkGroupSelect" @click="nearChangeData('c',3)">
            <span :class="pramsInfo.nearlyAwaiyRadio3 == 1?'checkActive':''"></span>
            半场
          </div>

        </div>
        <div class="switchTabs">
          <span @click="changelist(10,3)">近10</span>
          <span @click="changelist(20,3)">近20</span>
          <div :class="showPageNumber.nearly2 == 10?'nearly1':'nearly2'">{{showPageNumber.nearly2 == 10?'近10':'近20'}}
          </div>
        </div>
      </div>

      <div class="u-flex historyItem">
        <div class="itemsblock1">赛事</div>
        <div class="itemsblock1">比赛日期</div>
        <div class="itemsblock2">主队</div>
        <div class="itemsblock5">比分</div>
        <div class="itemsblock2" style="justify-content: flex-start;">客队</div>
        <div class="itemsblock5">半场</div>
        <div class="itemsblock5">角球</div>
        <div class="itemsblock5">胜负</div>
        <div class="itemsblock4">胜负</div>
        <div class="itemsblock4">让球</div>
        <div class="itemsblock5">走势</div>
        <div class="itemsblock5">进球数</div>
      </div>
      <!-- 初盘 -->
      <div class="u-flex historyItem" v-if="item.league"
        v-for="(item,index) in nearlyList2.awayRecordAnalysis.matchList" :key="index">
        <div class="itemsblock1">{{item.league.nameCnShort}}</div>
        <div class="itemsblock1">{{fifiData(item.matchInfo.matchStartTime)}}</div>

        <div class="itemsblock2"  :style="{'color':baseStateData(item,item.homeTeam.nameCn,pramsInfo.nearlyAwaiyRadio3,1).color}">{{item.homeTeam.nameCn}} <img
            style="margin-left:4px" v-if="item.homeTeam"
            :src="item.homeTeam.customLogo?item.homeTeam.customLogo:'/static/scope/defaultqiu.png'" alt="" srcset="">
        </div>


        <div class="itemsblock5 homeColorUp">{{item.matchData.homeScore}} - {{item.matchData.awayScore}}</div>
        <div class="itemsblock2" style="justify-content: flex-start;"
          :style="{'color':baseStateData(item,item.awayTeam.nameCn,pramsInfo.nearlyAwaiyRadio3,2).color}">
          <img v-if="item.homeTeam" style="margin-right:4px"
            :src="item.awayTeam.customLogo?item.awayTeam.customLogo:'/static/scope/defaultqiu.png'" alt="" srcset="">

          {{item.awayTeam.nameCn}}
        </div>


        <div class="itemsblock5"> {{item.matchData.homeHalfScore}}-{{item.matchData.awayHalfScore}}</div>
        <div class="itemsblock5">{{item.matchData.homeCornerNum}}-{{item.matchData.awayCornerNum}}</div>

        <div class="itemsblock5" :style="{'color':winstate(item,pramsInfo.nearlyAwaiyRadio3).color}">
          {{winstate(item,pramsInfo.nearlyAwaiyRadio3).name}}
        </div>
        <!-- 欧赔 初盘-->
        <div class="itemsblock4">
          <span>{{item.europeFirstHomeOdds}}</span>
          <span>{{item.europeFirstFlatOdds}}</span>
          <span>{{item.europeFirstAwayOdds}}</span>
        </div>
        <div class="itemsblock4">
          <span>{{item.asiaFirstHomeOdds}}</span>
          <span>{{item.asiaFirstGoal}}</span>
          <span>{{item.asiaFirstAwayOdds}}</span>
        </div>
        <div class="itemsblock5" :style="{'color':winrunState(item,1)}">
          {{item.asiaResult?item.asiaResult:'-'}}
        </div>
        <div class="itemsblock5" :style="{'color':winrunState(item,2)}">
          {{item.bsResult?item.bsResult:'-'}}
        </div>
      </div>
      <!--  -->
      <div class="totalTxt">
        两队近{{nearlyList2.awayRecordAnalysis.num}}场交锋 {{scoreDetail.homeTeam.nameCn}} 胜
        <span>{{nearlyList2.awayRecordAnalysis.winCount}}</span> 场，平 <span
          style="color: #1076E9;">{{nearlyList2.awayRecordAnalysis.flatCount}}</span> 场，负 <span
          style="#58AF66">{{nearlyList2.awayRecordAnalysis.loseCount}}</span>
        场，胜率：<span>{{mathData( nearlyList2.awayRecordAnalysis.winRate ,100)}}%</span>，赢率：<span>{{mathData(nearlyList2.awayRecordAnalysis.asiaRate ,100)}}%</span>，大率：<span>{{mathData( nearlyList2.awayRecordAnalysis.upRate , 100)}}%</span>
      </div>
    </div>


    <!-- 未来赛事 -->
    <div class="moduleName" v-if="futureList.homeFutureMatchList && futureList.homeFutureMatchList.length > 0">
      未来赛事
    </div>
    <div class="futureScope historyData"  v-if="futureList.homeFutureMatchList && futureList.homeFutureMatchList.length > 0">
        <div class="u-flex-y myfutureLeft" style="margin-right: 12px;">
          <div class="u-flex u-flex-items-center tablisthistory ">
              <img style="width: 20px;height: 20px;margin-right: 4px;" v-if="scoreDetail.homeTeam"
                :src="scoreDetail.homeTeam.customLogo?scoreDetail.homeTeam.customLogo:'/static/scope/defaultqiu.png'" alt=""
                srcset="">
              <div v-if="scoreDetail.homeTeam">{{scoreDetail.homeTeam.nameCn}}</div>
          </div>
          <div class="u-flex historyItem firstheader" style="background-color: #fff;">
             <div class="itemsblock1">赛事</div>
             <div class="itemsblock1">比赛日期</div>
             <div class="itemsblock2">主队</div>
             <div class="itemsblock5">比分</div>
             <div class="itemsblock2" style="justify-content: flex-start;">客队</div>
             <div class="itemsblock5">间隔</div>
          </div>
          <div class="historyItem u-flex" v-for="(item,index) in  futureList.homeFutureMatchList" :key="index">
            <div class="itemsblock1">{{item.league.nameCnShort}}</div>
            <div class="itemsblock1">{{fifiData(item.matchInfo.matchStartTime)}}</div>
            <div class="itemsblock2">{{item.homeTeam.nameCn}}</div>
            <div class="itemsblock5">vs</div>
            <div class="itemsblock2" style="justify-content:flex-start;">{{item.awayTeam.nameCn}}</div>
            <div class="itemsblock5">{{item.intervalDays}}天后</div>
          </div>
        </div>
        <div class="u-flex-y myfutureLeft">
          <div class="u-flex u-flex-items-center tablisthistory ">
              <img style="width: 20px;height: 20px;margin-right: 4px;" v-if="scoreDetail.awayTeam"
                :src="scoreDetail.awayTeam.customLogo?scoreDetail.awayTeam.customLogo:'/static/scope/defaultqiu.png'" alt=""
                srcset="">
              <div v-if="scoreDetail.awayTeam">{{scoreDetail.awayTeam.nameCn}}</div>
          </div>
          <div class="u-flex historyItem firstheader" style="background-color: #fff;">
             <div class="itemsblock1">赛事</div>
             <div class="itemsblock1">比赛日期</div>
             <div class="itemsblock2">主队</div>
             <div class="itemsblock5">比分</div>
             <div class="itemsblock2" style="justify-content: flex-start;">客队</div>
             <div class="itemsblock5">间隔</div>
          </div>
          <div class="historyItem u-flex" v-for="(item,index) in   futureList.awayFutureMatchList" :key="index">
            <div class="itemsblock1">{{item.league.nameCnShort}}</div>
            <div class="itemsblock1">{{fifiData(item.matchInfo.matchStartTime)}}</div>
            <div class="itemsblock2">{{item.homeTeam.nameCn}}</div>
            <div class="itemsblock5">vs</div>
            <div class="itemsblock2" style="justify-content:flex-start;">{{item.awayTeam.nameCn}}</div>
            <div class="itemsblock5">{{item.intervalDays}}天后</div>
          </div>
        </div>
    </div>


   <!-- <div class="emitData"  v-if="futureList.homeFutureMatchList.length == 0">
       <div class="noDatas">
         <img src="/static/dataimg/no_data.png" alt="" srcset="">
         <span>
           暂无数据
         </span>
       </div>
    </div> -->


    <div style="height: 100px;"></div>
  </div>
</template>

<script>
  import moment from 'moment';
  import {
    matchDetail,
    teamLeagueRank,
    matchBeRelevanceAnchorList,
    teamHistoryConfrontation,
    teamRecentRecord,
    futureMatchList
  } from '@/api/scope.js';
  export default {
    props: {
      matchId: {
        type: String,
        default: '',
      },
      info: {
        // 声明类型
        type: Object,
        //声明是否必需
        require: true,
        // 声明默认值
        default: {}
      }
    },
    watch: {
      info: {
        handler(e) {
          console.log(e);
        },
        deep: true
      }
    },
    data() {
      return {
        noCurrentData:false,
        scoreDetail: {},
        startList: {},
        pageTeam: 10,
        sameTeam: '',
        ContentInfo: '',
        userLive: {},
        historyList: [],
        nearlyList: [],
        nearlyList2: [],
        futureList:[],
        showPageNumber: {
          history: 10,
          nearly1: 10,
          nearly2: 10,
        },
        pramsInfo: {
          historyRadio1: "",
          historyRadio2: "",
          historyRadio3: "",
          nearlyHomeRadio1: "",
          nearlyHomeRadio2: "",
          nearlyHomeRadio3: "",
          nearlyAwaiyRadio1: "",
          nearlyAwaiyRadio2: "",
          nearlyAwaiyRadio3: "",
        }
      }
    },
    created() {
      this.scoreDetail = this.info;
      this.initData();
    },
    methods: {
      //
      // lastData(){
      //   if( (this.startList.homeTeamLeagueRank.length >0) || (this.startList.awayTeamLeagueRank.length>0) || (this.historyList.matchList.length > 0) || this.futureList.homeFutureMatchList.length > 0

      //  && this.nearlyList.homeRecordAnalysis && this.nearlyList.homeRecordAnalysis.matchList.length > 0  this.nearlyList2.awayRecordAnalysis.matchList.length >0
      //   ){
      //     console.log('没有数据1');
      //     return false
      //   }else{
      //     console.log('没有数据2');
      //     return true
      //   }
      // },
      winstate(item,half){
        let type = 0,name = ''
        if(item.homeTeam.nameCn == this.scoreDetail.homeTeam.nameCn){
          type = 1;name =item.homeTeam.nameCn
        }
        if(item.awayTeam.nameCn == this.scoreDetail.homeTeam.nameCn){
          type = 2;name =item.awayTeam.nameCn
        }
        if(item.awayTeam.nameCn == this.scoreDetail.awayTeam.nameCn){
          type = 2;name =item.awayTeam.nameCn
        }
        if(item.homeTeam.nameCn == this.scoreDetail.awayTeam.nameCn){
          type = 1;name =item.homeTeam.nameCn
        }
        return this.baseStateData(item,name,half,type);
      },
      matchState(){
        return {
          color:'red',
          name:'测试'
        }
      },
      baseStateData(item,name,half,type) {
          let obj= {
            status1:{
              color:'#ED1010',
              name:'胜'
            },
            status2:{
              color:'#58AF66',
              name:'负'
            },
            status3:{
              color:'#1076E9',
              name:'平'
            },
            status4:{
              color:'#333',
              name:''
            }
          };



          // 半场比分
          if(half == 1){
            if (item.matchData.homeHalfScore === item.matchData.awayHalfScore && (name === this.scoreDetail.homeTeam.nameCn ||name === this.scoreDetail.awayTeam.nameCn )) {
              return obj.status3
            }
            //左边
            if(type ==1){
              // 传进来的为主队
              if (name === this.scoreDetail.homeTeam.nameCn) {
                 return item.matchData.homeHalfScore > item.matchData.awayHalfScore?obj.status1:obj.status2;
              }
              // 传进来的为客队
              if (name === this.scoreDetail.awayTeam.nameCn) {
                 return item.matchData.homeHalfScore > item.matchData.awayHalfScore?obj.status1:obj.status2;
              }
             // 右边
            }else{

              // 传进来的为主队
              if (name === this.scoreDetail.homeTeam.nameCn) {
                 return item.matchData.homeHalfScore > item.matchData.awayHalfScore?obj.status2:obj.status1;
              }
              // 传进来的为客队
               if (name === this.scoreDetail.awayTeam.nameCn) {
                  return item.matchData.homeHalfScore > item.matchData.awayHalfScore?obj.status2:obj.status1;
               }

            }
          // 全场比分
          }else{
              if (item.matchData.homeScore == item.matchData.awayScore && (name === this.scoreDetail.homeTeam.nameCn ||name === this.scoreDetail.awayTeam.nameCn )) {
                 return obj.status3
              }
             if(type ==2){
                // 传进来的为主队
               if (name === this.scoreDetail.homeTeam.nameCn) {
                  return item.matchData.homeHalfScore > item.matchData.awayScore?obj.status2:obj.status1;
               }
               // 传进来的为客队
               if (name === this.scoreDetail.awayTeam.nameCn) {
                  return item.matchData.homeScore > item.matchData.awayScore?obj.status2:obj.status1;
               }

             }else{
              // 传进来的为主队
               if (name === this.scoreDetail.homeTeam.nameCn) {
                  return item.matchData.homeScore > item.matchData.awayScore?obj.status1:obj.status2;
               }
               // 传进来的为客队
               if (name === this.scoreDetail.awayTeam.nameCn) {
                  return item.matchData.homeScore > item.matchData.awayScore?obj.status1:obj.status2;

               }
             }
          }

          return obj.status4
      },
      // 小数点精度问题
      mathData(a, b) {
        return parseFloat(a * b).toFixed(2)
      },
      // 切换历史交锋
      nearChangeData(e, b) {
        console.log('切换历史交锋', e, b);
        if (b == 1) {
          switch (e) {
            case 'a':
              if (this.pramsInfo.historyRadio1 == 1) {
                this.pramsInfo.historyRadio1 = '';
              } else {
                this.pramsInfo.historyRadio1 = 1;
              }
              break;
            case 'b':
              if (this.pramsInfo.historyRadio2 == 1) {
                this.pramsInfo.historyRadio2 = '';
              } else {
                this.pramsInfo.historyRadio2 = 1;
              }
              break;
            case 'c':
              if (this.pramsInfo.historyRadio3 == 1) {
                this.pramsInfo.historyRadio3 = '';
              } else {
                this.pramsInfo.historyRadio3 = 1;
              }
              break;
            default:
              this.pramsInfo.historyRadio1 = '';
              break;
          }
          this.rediohistoryList()
        }
        // 近期战绩
        if (b == 2) {
          switch (e) {
            case 'a':
              if (this.pramsInfo.nearlyHomeRadio1 == 1) {
                this.pramsInfo.nearlyHomeRadio1 = '';
              } else {
                this.pramsInfo.nearlyHomeRadio1 = 1;
              }
              break;
            case 'b':
              if (this.pramsInfo.nearlyHomeRadio2 == 1) {
                this.pramsInfo.nearlyHomeRadio2 = '';
              } else {
                this.pramsInfo.nearlyHomeRadio2 = 1;
              }
              break;
            case 'c':
              if (this.pramsInfo.nearlyHomeRadio3 == 1) {
                this.pramsInfo.nearlyHomeRadio3 = '';
              } else {
                this.pramsInfo.nearlyHomeRadio3 = 1;
              }
              break;
            default:
              this.pramsInfo.nearlyHomeRadio3 = '';
              break;
          }
          this.redionearlyList()
        }
        if (b == 3) {
          switch (e) {
            case 'a':
              if (this.pramsInfo.nearlyAwaiyRadio1 == 1) {
                this.pramsInfo.nearlyAwaiyRadio1 = '';
              } else {
                this.pramsInfo.nearlyAwaiyRadio1 = 1;
              }
              break;
            case 'b':
              if (this.pramsInfo.nearlyAwaiyRadio2 == 1) {
                this.pramsInfo.nearlyAwaiyRadio2 = '';
              } else {
                this.pramsInfo.nearlyAwaiyRadio2 = 1;
              }
              break;
            case 'c':
              if (this.pramsInfo.nearlyAwaiyRadio3 == 1) {
                this.pramsInfo.nearlyAwaiyRadio3 = '';
              } else {
                this.pramsInfo.nearlyAwaiyRadio3 = 1;
              }
              break;
            default:
              this.pramsInfo.nearlyAwaiyRadio3 = '';
              break;
          }
          this.redionearlyList2()
        }
      },
      // 刷新接口
      rediohistoryList() {
        this.pramsInfo.historyRadio;
        // 历史交锋
        teamHistoryConfrontation({
          matchId: this.info.matchId,
          limit: this.showPageNumber.history,
          sameTeam: this.pramsInfo.historyRadio1,
          sameLeague: this.pramsInfo.historyRadio2,
          isHalf: this.pramsInfo.historyRadio3,
        }).then(res => {
          if (res.data.code == 200) {
            this.historyList = res.data.data
          }
        })
      },
      // 近期战绩主队
      redionearlyList(e) {
        // 近期战绩
        teamRecentRecord({
          matchId: this.info.matchId,
          limit: this.showPageNumber.nearly1,
          sameTeam: this.pramsInfo.nearlyHomeRadio1,
          sameLeague: this.pramsInfo.nearlyHomeRadio2,
          isHalf: this.pramsInfo.nearlyHomeRadio3,
        }).then(res => {
          if (res.data.code == 200) {
            this.nearlyList = res.data.data
          }
        })
      },
      // 近期战绩客队
      redionearlyList2(e) {
        // 近期战绩
        teamRecentRecord({
          matchId: this.info.matchId,
          limit: this.showPageNumber.nearly2,
          sameTeam: this.pramsInfo.nearlyAwaiyRadio1,
          sameLeague: this.pramsInfo.nearlyAwaiyRadio2,
          isHalf: this.pramsInfo.nearlyAwaiyRadio3,
        }).then(res => {
          if (res.data.code == 200) {
            this.nearlyList2 = res.data.data
          }
        })
      },
      changelist(val, i) {
        if (i == 1) {
          this.showPageNumber.history = val;
          this.rediohistoryList()
        }
        if (i == 2) {
          this.showPageNumber.nearly1 = val;
          this.redionearlyList()
        }
        if (i == 3) {
          this.showPageNumber.nearly2 = val;
          this.redionearlyList2()
        }
        console.log('切换', val);
        // 刷新接口
      },
      fiftime(val) {
        return moment.unix(val).format('YYYY-MM-DD HH:mm:ss')
      },
      fifiData(val) {
        return moment.unix(val).format('YYYY-MM-DD')
      },
      initData() {
        // // 比赛详情
        // matchDetail({
        //   matchId: '38387',
        // }).then(res => {
        //   if (res.data.code == 200) {
        //     this.scoreDetail = res.data.data
        //   }
        // })
        // 指定比赛被关联的主播信息
        matchBeRelevanceAnchorList({
          matchId: this.info.matchId,
          matchType: 1
        }).then(res => {
          if (res.data.code == 200) {
            this.userLive = res.data.data
          }
        })
        // 联赛积分排名
        teamLeagueRank({
          matchId: this.info.matchId,
        }).then(res => {
          if (res.data.code == 200) {
            this.startList = res.data.data
          }
        })


        this.rediohistoryList()
        this.redionearlyList()
        this.redionearlyList2();


        // 未来赛事
        futureMatchList({
          matchId: this.info.matchId,
        }).then(res=>{
          if(res.data.code ==200){
            this.futureList = res.data.data
          }
        })

      },
      // 走势--进球数颜色
      winrunState(val, state) {
        if (state == 1) {
          switch (val.asiaResultValue) {
            case 1:
              return '#ED1010'
              break;
            case 0:
              return '#1076E9'
              break;
            case -1:
              return '#58AF66'
              break;
            default:
              return '#333'
              break;
          }
        }
        if (state == 2) {
          switch (val.bsResultValue) {
            case 1:
              return '#ED1010'
              break;
            case 0:
              return '#1076E9'
              break;
            case -1:
              return '#58AF66'
              break;
            default:
              return '#333'
              break;
          }
        }
      },

      // 亚盘
      startGoal1(type, item) {
        switch (type) {
          case 1: // 为空
            return ''
          case 2: // 初盘
            return item.asiaOddsVO.firstHomeOdds;
          case 3: // 即时
            return item.asiaOddsVO.realHomeOdds;
          case 4: // 走低
            return item.asiaOddsVO.timelyHomeOdds;
          default:
            return ''
        }
      },
      // 大小球
      startGoal2(type, item) {
        switch (type) {
          case 1: // 为空
            return ''
          case 2: // 初盘
            return item.bsOddsVO.firstUpOdds;
          case 3: // 即时
            return item.bsOddsVO.realUpOdds;
          case 4: // 走低
            return item.bsOddsVO.timelyUpOdds;
          default:
            return ''
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/style/flex.scss';
  .sai_databox{
    background-color: #fff;
  }
  .noDatas{
    width: 100%;
    display: flex;
    justify-content: center;
    padding:50px 0;
    flex-direction: column;
    align-items: center;
    span{
     margin-top: 20px;
     font-size: 14px;
     color: #999999;
    }
    img{
      width: 189px;
      height: 238px;
    }
  }

  .homeColorUp {
    color: #ED1010 !important;
  }

  .homeColorDown {
    color: #58AF66;
  }

  .homeColorto {
    color: #1076E9;
  }

  .totalTxt {
    text-align: center;
    height: 36px;
    line-height: 36px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    background: #FFFFFF;
    color: #666666;
    border-top: 1px solid rgba(0, 0, 0, .3);

    span {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ED1010;
    }
  }

  .switchTabs {
    width: 70px;
    height: 20px;
    border-radius: 2px;
    display: flex;
    background-color: #eeeeee;
    position: relative;
    cursor: pointer;

    span {
      cursor: pointer;
      color: #333;
      width: 34px;
      text-align: center;
      font-size: 12px;
      height: 20px;
      line-height: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }

    .nearly1 {
      width: 34px;
      height: 20px;
      transition: all .2s;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #721EDC;
      font-size: 12px;
      border-radius: 2px;
      z-index: 0;
      position: absolute;
      color: #fff !important;
      left: 0;
    }

    .nearly2 {
      width: 34px;
      z-index: 0;
      height: 20px;
      transition: all .2s;
      display: flex;
      justify-content: center;
      font-size: 12px;
      align-items: center;
      color: #fff !important;
      background: #721EDC;
      border-radius: 2px;
      position: absolute;
      left: 50%;
    }
  }

  .analysis_box {
    display: flex;
    align-items: center;
    flex-direction: column;
    background: #F7F8FA;
    min-height: 100vh;
    margin-bottom: 100px;

    .tablisthistory {
      display: flex;
      width: 100%;
      font-size: 14px;
      padding: 0 12px;
      box-sizing: border-box;
      height: 45px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      background-color: #fff;
      border-bottom: 1px solid rgba(0, 0, 0, .1);

      /deep/ .el-radio {
        //添加边框
        /* border: 1px solid rgb(207, 204, 204); */
        //选中时边框的颜色
        /* &.is-checked {
                border: 1px solid #28d4c1 !important;
              } */
        //鼠标滑过改变字体和小圆圈边框的样式
        &:hover {
          border-color: #721EDC !important;
          color: #721EDC !important;

          //鼠标滑过时小圆点边框显示
          .el-radio__inner {
            border-color: #721EDC;
          }
        }

        .el-radio__input {
          margin-bottom: px(5);

          //选中时的样式
          &.is-checked {
            .el-radio__inner {
              //选中时小圆圈的的颜色
              background-color: #721EDC;
              border-color: #721EDC;
            }

            +.el-radio__label {
              //选中时字体的颜色
              color: #721EDC !important;
              font-size: 14px;
            }
          }

          .el-radio__inner {

            // 鼠标滑过小圆点时的样式
            &:hover {
              border-color: #721EDC;
            }
          }
        }
      }


    }

    .scorebang {
      width: 1200px;
      background: #F7F8FA;
      box-shadow: 0px 2px 10px 0px rgba(46,48,52,0.1000);
    }
    .futureheader{
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      text-align: center;
      margin: 12px;
    }
    .futureScope{
      display: flex;

      .itemsblock2{
        width: 140px !important;
        height: 38px;
      }
      .itemsblock5{
        width: 60px !important;
        text-align: center;
      }
      .myfutureLeft{
        max-width: 594px;
        background: #FFFFFF;
        .historyItem{
          font-size: 14px;
        }
        .firstheader{
          div{
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999 !important;
          }
        }
      }
    }
    .historyData {
      width: 1200px;
      background: #FFFFFF;
      box-shadow: 0px 2px 10px 0px rgba(46,48,52,0.1000);
      .checkGroupSelect:hover {
        color: #721EDC;

        span {
          border: 1px solid #721EDC;
          ;
        }
      }

      .checkGroupSelect {
        display: flex;
        margin-right: 30px;
        cursor: pointer;
        align-items: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        height: 18px;

        .checkActive {
          background-color: #721EDC;
        }

        span {
          width: 16px;
          height: 16px;
          display: inline-block;
          border-radius: 6px;
          border: 1px solid rgba(0, 0, 0, .1);
          margin-right: 4px;
          background-color: #fff;
        }
      }

      .historyItem:nth-child(2n + 1) {
        background-color: #eeeeee;
      }

      .historyItem:nth-child(1) {
        color: #999999 !important;
      }

      .historyItem {
        background-color: #fff;
        width: 100%;
        display: flex;
        height: 40px;
        align-items: center;
        justify-content: space-around;

        div {
          text-align: center;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .itemsblock1 {
          width: 100px;
        }

        .itemsblock2 {
          width: 200px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          padding: 0 12px;
          box-sizing: border-box;

          img {
            width: 16px;
            height: 16px;
          }
        }

        .itemsblock3 {
          width: 60px;
        }

        .itemsblock4 {
          width: 150px;
          display: flex;
          height: 50px;
          line-height: 50px;
          justify-content: center;

          span {
            display: inline-block;
            text-align: center;
            width: 50px;
          }

          ;
        }

        .itemsblock5 {
          width: 50px;
        }
      }
    }

    .moduleName {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333333;
      text-align: center;
      padding:24px 0 12px;
    }

    .leftInfo {
      width: 594px;
      height: 202px;
      background: #FFFFFF;
      background: #FFFFFF;
      box-shadow: 0px 2px 10px 0px rgba(46,48,52,0.1000);
      .title {
        flex: 1;
        padding: 0 12px;
        border-bottom: 1px solid rgba(0, 0, 0, .1);
        height: 50px;
        line-height: 50px;
        text-align: left;
        display: flex;
        align-items: center;

        img {
          margin-right: 6px;
          vertical-align: middle;
          width: 20px;
          height: 20px;
        }
      }

      .tableName,
      .datainfo {
        border-bottom: 1px solid rgba(0, 0, 0, .1);
        padding: 0 10px;
        .bggreey{
          background-color: #f2f2f2 !important;
        }
        div {
          font-size: 14px;
          text-align: center;
          width: 59px;
          height: 38px;
          line-height: 38px;
        }
      }

      .datainfo:last-child {
        border-bottom: none !important;
      }

      .datainfo {
        flex: 1;
        color: #333333;
        display: flex;
        justify-content: space-between;
      }

      .tableName {
        flex: 1;
        color: #999999;
      }



    }

    .page_top {
      max-width: 1200px;

      .livesitem {
        padding: 0 2px;
        margin-right: 27px;
        box-sizing: border-box;
        width: 142px;
        height: 34px;
        background: rgba(0, 0, 0, .3);
        border-radius: 17px;

        img {
          width: 28px;
          height: 28px;
          border-radius: 50%
        }

        span {
          flex: 1;
          color: #eee;
          margin-left: 4px;
          line-height: 34px;
        }
      }

      .homescoreName {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        margin: 20px;

        img {
          margin: 0 4px;
          width: 40px;
          border-radius: 50%;
          height: 40px;
          // background: #FFFFFF;

        }
      }

      .btnTab {
        transform: translateY(-25px);
        width: 1200px;
        height: 52px;
        background: #1B933F;
        border-radius: 0px 0px 6px 6px;

        div {
          width: 160px;
          text-align: center;
          cursor: pointer;
          height: 52px;
          line-height: 52px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
        }

        .activeDetault {
          width: 160px;
          height: 52px;
          line-height: 50px;
          background: #0C702A;
        }
      }

      .header_aways {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 1200px;
        height: 260px;
        background: linear-gradient(90deg, rgba(0, 0, 0, 0.1000) 0%, rgba(0, 0, 0, 0.4000) 100%);
        border-radius: 6px;
        position: relative;

        .myContent {
          position: relative;
          z-index: 1;
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
        }

        .addTime {
          margin-top: 12px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
        }

        .Scoretime {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
        }

        .TOPbg {
          position: absolute;
          width: 1200px;
          height: 260px;
          background: linear-gradient(90deg, rgba(0, 0, 0, 0.1000) 0%, rgba(0, 0, 0, 0.4000) 100%);
          border-radius: 6px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/components/lz_matchResult.vue